export default class KeyAreaFiltered {
  id: string;

  name: string;

  lastModifiedDate: string;

  modifiedBy: string;

  loadingOpenModalWarning: boolean = false;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.lastModifiedDate = obj.lastModifiedDate || '';
    this.modifiedBy = obj.modifiedBy || '';
    this.loadingOpenModalWarning = obj.loadingOpenModalWarning || false;
  }
}
